import { render, staticRenderFns } from "./DashboardSkeleton.vue?vue&type=template&id=590c3250&scoped=true"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardSkeleton.vue?vue&type=style&index=0&id=590c3250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c3250",
  null
  
)

export default component.exports